import { Injectable, OnDestroy } from '@angular/core';
import { ApiserviceService } from '../../apiservice.service';
import { ShareService } from './share.service';
import { Subscription } from 'rxjs';

@Injectable()
export class AppNotificationService implements OnDestroy {
  notification_list: any = [];
  top_notifications: any = [];
  notification_detail: any;
  private subs = new Subscription();
  constructor(private readonly api: ApiserviceService, private readonly share: ShareService) {
  }

  getCount(offset = 0){
    if(this.api.user_id && this.api.city_id){
      let url = `deapp/notification/${this.api.user_id}?notification_status=sent&offset=${offset}&sort_by=added_date`;
      const countSub = this.api.getEmsData(url).subscribe({next:(res:any) => {
         const unreadCount = (res ?? [])?.filter?.(n => n.email_status !== 'read')?.length ?? 0;
        if(this.share.adminComp){
          this.share.adminComp.notifycounter = unreadCount;
        }
      }, error:err=>{
        if(this.share.adminComp) this.share.adminComp.notifycounter = 0;
      }
    })
      this.subs.add(countSub);
    }

  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
